import { ImagemBase64 } from "src/app/model/imagemBase64";
import { Usuario } from "../usuario/usuario";

export class NotaTicket {
    id?: number;
    texto: string;
    createdAt: any;
    usuario: string;
    ticket: number;
    apresentarParceiro?: boolean;
    imagensBase64?: ImagemBase64[];


    constructor(id: number, texto: string, createdAt: any, usuario: string, ticketId: number, apresentarParceiro?: boolean, imagensBase64?: ImagemBase64[]) {
        this.id = id;
        this.texto = texto;
        this.createdAt = createdAt;
        this.usuario = usuario;
        this.ticket = ticketId;
        this.imagensBase64 = imagensBase64;
        this.apresentarParceiro = apresentarParceiro;
    }
}

export interface Page<T> {
    content: T[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
    last: boolean;
}
